



























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Connector from '@vue-polkadot/vue-api';
import BN from 'bn.js';
import ProgressBar from '@/components/shared/ProgressBar.vue';
import { DeriveStakingOverview } from '@polkadot/api-derive/types';
import { BlockNumber } from '@polkadot/types/interfaces';
import { DeriveSessionProgress } from '@polkadot/api-derive/types';

const components = { ProgressBar }


@Component({ components })
export default class Summary extends Vue {
  @Prop() private readonly overview!: DeriveStakingOverview;
  @Prop() private readonly currentBlock!: BlockNumber;
  @Prop() private readonly session!: DeriveSessionProgress;
  @Prop() private readonly waiting!: number;


  get totalValidators() {
    return this.overview.validatorCount || 0
  }

  get validators() {
    return this.overview.validators?.length || 0
  }

  get lastBlock() {
    return this.currentBlock?.toString || 0;
  }

  get sessionLabel(): string {
    return this.session?.isEpoch ? 'Epoch' : 'Session'
  }

  get sessionLength() {
    return this.session?.sessionLength?.toNumber()
  }

  get sessionProgress() {
    return this.session?.sessionProgress?.toNumber()
  }

  get eraLength() {
    return this.session?.eraLength?.toNumber();
  }

  get eraProgress() {
    return this.session?.eraProgress?.toNumber();
  }

  private nominators: number = 0;
  
}


